var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "sidebar-item flex-1",
      class: { disabled: _vm.isActive === false },
    },
    [
      _c("div", { staticClass: "d-flex justify-content-between" }, [
        _c("div", { staticClass: "font-weight-bold text-white" }, [
          _vm._v(_vm._s(_vm._f("trans")("Prompt"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text-muted font-weight-bold" }),
      ]),
      _vm._v(" "),
      _c("prompt"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }